<div class="upload-buttons__wrap">
  @if (hasCardButtonEnabled) {
    <div class="upload-buttons__wrap-btn-container">
      <div class="ep_single_tile top" [class.active]="taxCardAddService.hasEmployers">
        <div
          class="ep_desc_wrap"
          (click)="taxCardAddService.onChooseIfHasCard();"
          >
          <div class="icon_tile_wrap">
            <img src="../../../../../assets/svg/11.svg" class="icon_tile lg">
          </div>
          <div class="title_tile_sm">
            {{ 'EMPLOYER.TILE_TITLE' | translate }}
          </div>
        </div>
      </div>
      @if (taxCardAddService.uploadingScan) {
        <app-button-tile-loader></app-button-tile-loader>
      }
    </div>
  }

  @if (uploadButtonEnabled) {
    <div class="upload-buttons__wrap-btn-container">
      <label>
        <input
          type="file"
          accept="application/pdf"
          [disabled]="taxCardAddService.uploadingScan"
          (change)="onUpload()"
          #pdfField
          />
        <a
          class="ep_single_tile top"
          [class.is-loading]="taxCardAddService.uploadingScan"
          >
          <div class="ep_desc_wrap">
            <div class="icon_tile_wrap">
              <img src="../../../../../assets/svg/upload_pdf.svg" class="icon_tile sm">
            </div>
            <h4 class="title_tile_sm sm_m">
              {{ 'EMPLOYER.UPLOAD_TAXCARD_PDF' | translate }}
            </h4>
          </div>
        </a>
        @if (taxCardAddService.uploadingScan) {
          <app-button-tile-loader></app-button-tile-loader>
        }
      </label>
    </div>
  }

  @if (taxCardAddService.enableScanUpload && uploadButtonEnabled && taxCardAddService.canSnapTaxCard()) {
    <div class="upload-buttons__wrap-btn-container">
      <label>
        <div
          class="ep_single_tile top"
          [class.is-loading]="taxCardAddService.uploadingScan"
          (click)="onPhotoClick()"
          >
          <div class="ep_desc_wrap">
            <div class="icon_tile_wrap">
              <img src="../../../../../assets/svg/upload_jpg.svg" class="icon_tile sm">
            </div>
            <div class="title_tile_sm sm_m">
              {{ 'EMPLOYER.UPLOAD_TAXCARD_PDF' | translate }}
            </div>
          </div>
        </div>
        @if (taxCardAddService.uploadingScan) {
          <app-button-tile-loader></app-button-tile-loader>
        }
      </label>
    </div>
  }

  @if (manuallyAddButtonEnabled) {
    <div class="upload-buttons__wrap-btn-container" [attr.data-cy]="'btnTaxCardAddManually'">
      <div class="ep_single_tile top" [class.is-loading]="taxCardAddService.uploadingScan">
        <div class="ep_desc_wrap" (click)="taxCardAddService.onManuallyTaxCardAdded();" [attr.data-cy]="'btnAddTaxCardManually'">
          <div class="icon_tile_wrap">
            <img src="../../../../../assets/svg/details_manually.svg" class="icon_tile sm">
          </div>
          <div class="title_tile_sm">
            {{ 'EMPLOYER.MANUAL_CARD_LABEL' | translate }}
          </div>
        </div>
      </div>
      @if (taxCardAddService.uploadingScan) {
        <app-button-tile-loader></app-button-tile-loader>
      }
    </div>
  }
</div>
